import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import {
  NotificationInstanceSummary,
  RuntimeApiService,
} from '@flowx/designer/shared/api/runtime.api'
import { GridSearchService } from '@flowx/designer/shared/services/grid-search.service'
import {
  PageRequest,
  PaginatedEndpoint,
  PaginatedResponse,
  Sort,
} from '@flowx/designer/shared/services/paginated-datasource'
import { UrlParametersStoreService } from '@flowx/designer/shared/services/url-parameters-store.service'

const SORT_FIELD = 'sentDate'

interface InstanceNotificationsQueryParams {
  processInstanceUuid: string
}

@Injectable({
  providedIn: 'root',
})
export class InstanceNotificationsService extends GridSearchService<InstanceNotificationsQueryParams> {
  #runtimeApi = inject(RuntimeApiService)
  #urlParametersStoreService = inject(UrlParametersStoreService)

  private initialQuery: Partial<InstanceNotificationsQueryParams> = {}

  getGridEndpointInfo(): {
    endpoint: PaginatedEndpoint<any, InstanceNotificationsQueryParams>
    sort: Sort
    query: Partial<InstanceNotificationsQueryParams>
  } {
    return {
      endpoint: this.getNotifications.bind(this),
      sort: {
        property: SORT_FIELD,
        direction: 'desc',
      },
      query: this.initialQuery,
    }
  }

  getNotifications(
    params: PageRequest,
    query: Partial<InstanceNotificationsQueryParams>
  ): Observable<PaginatedResponse<NotificationInstanceSummary>> {
    const { appId } = this.#urlParametersStoreService.urlParameters

    return this.#runtimeApi.getNotificationInstanceSummaries(appId, {
      ...params,
      processInstanceUuid: query.processInstanceUuid,
    })
  }
}
